<template>
  <v-row dense>
    <v-col
      v-for="item in items"
      :key="item.key"
      cols="12"
      sm="6"
      lg="3"
    >
      <!-- `clickable` este opt-in: consumatorii existenți rămân carduri pasive. -->
      <v-card
        class="ncrm-home-kpi-cards__card pa-3 h-100"
        :class="[`ncrm-home-kpi-cards__card--${item.color}`, { 'ncrm-home-kpi-cards__card--clickable': item.clickable }]"
        :role="item.clickable ? 'button' : undefined"
        :tabindex="item.clickable ? 0 : undefined"
        @click="item.clickable && $emit('select', item)"
        @keydown.enter.prevent="item.clickable && $emit('select', item)"
        @keydown.space.prevent="item.clickable && $emit('select', item)"
      >
        <div class="d-flex align-center justify-space-between ga-2 mb-1">
          <div class="text-caption text-medium-emphasis text-left">{{ item.label }}</div>
          <v-icon :color="item.color === 'neutral' ? undefined : item.color" size="15" style="opacity:0.7">{{ item.icon }}</v-icon>
        </div>
        <div class="d-flex align-center justify-space-between ga-2">
          <div class="text-h6 font-weight-bold ncrm-text-strong text-left">
            {{ item.displayValue !== undefined ? item.displayValue : formatNumber(item.value) }}
          </div>
          <v-icon v-if="item.clickable" size="18" class="ncrm-home-kpi-cards__chevron">mdi-chevron-right</v-icon>
        </div>
        <div v-if="item.hint" class="text-caption text-medium-emphasis text-left">{{ item.hint }}</div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { formatDisplayNumber } from "@/Utile/displayFormat.mjs";
export default {
  name: "NcrmHomeKpiCards",
  emits: ["select"],
  props: {
    /**
     * Array of KPI items.
     * Each item: { key: String, label: String, value: Number, icon: String, color: String }
     * Optional: displayValue (String) — shown as-is instead of the numeric formatting
     * (e.g. pre-formatted percentages).
     * Optional: hint (String) — the unit the KPI counts, shown under the value.
     * Optional: clickable (Boolean) — makes the card a keyboard-accessible button that
     * emits `select(item)`; used for KPI drill-down.
     * Supported colors: primary | error | success | warning | info | neutral
     * (`neutral` = a quiet border for states that must not read as an alert).
     */
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    formatNumber(value) {
      const parsed = Number(value);
      return Number.isFinite(parsed)
        ? formatDisplayNumber(parsed)
        : "-";
    },
  },
};
</script>

<style scoped>
.ncrm-home-kpi-cards__card {
  border-left: 3px solid transparent;
}
.ncrm-home-kpi-cards__card--clickable { cursor: pointer; transition: background-color .15s ease, box-shadow .15s ease; }
.ncrm-home-kpi-cards__card--clickable:hover { background-color: rgba(var(--v-theme-primary), 0.04); }
.ncrm-home-kpi-cards__card--clickable:focus-visible { outline: 2px solid rgb(var(--v-theme-primary)); outline-offset: 2px; }
.ncrm-home-kpi-cards__chevron { opacity: .45; }
.ncrm-home-kpi-cards__card--clickable:hover .ncrm-home-kpi-cards__chevron { opacity: .9; }
.ncrm-home-kpi-cards__card--primary { border-left-color: rgb(var(--v-theme-primary)); }
.ncrm-home-kpi-cards__card--error   { border-left-color: rgb(var(--v-theme-error)); }
.ncrm-home-kpi-cards__card--success { border-left-color: rgb(var(--v-theme-success)); }
.ncrm-home-kpi-cards__card--warning { border-left-color: rgb(var(--v-theme-warning)); }
.ncrm-home-kpi-cards__card--neutral { border-left-color: rgba(var(--v-theme-on-surface), 0.28); }
.ncrm-home-kpi-cards__card--info    { border-left-color: rgb(var(--v-theme-info)); }
</style>
